<template>
    <div v-if="toggleCustomAddressCorrection" class="custom-address-suggestion-container">
        <div class="custom-address-inner-container">
            <div class="custom-address-text">
                <h3>You entered</h3>
                <div class="entered-address-container">
                    <p v-if="(shipmentData.serviceAddress) && (currentActive == 1)">{{shipmentData.serviceAddress.address.address1}}, {{shipmentData.serviceAddress.address.city}}, {{shipmentData.serviceAddress.address.state}} {{shipmentData.serviceAddress.address.zipCode}}</p>
                    <p v-if="(shipmentData.deliveryPickup) && (currentActive == 3) && (showPickupLogic == true)">{{shipmentData.deliveryPickup.address.address1}}, {{shipmentData.deliveryPickup.address.city}}, {{shipmentData.deliveryPickup.address.state}} {{shipmentData.deliveryPickup.address.zipCode}}</p>
                    <p v-if="shipmentData.address1">{{shipmentData.address1}}, {{shipmentData.city}}, {{shipmentData.state}} {{shipmentData.zipCode}}</p>
                    <p v-if="shipmentData.pickupAddress1">{{shipmentData.pickupAddress1}}, {{shipmentData.pickupCity}}, {{shipmentData.pickupState}} {{shipmentData.pickupZipCode}}</p>
                    <p v-if="shipmentData.deliveryAddress1">{{shipmentData.deliveryAddress1}}, {{shipmentData.deliveryCity}}, {{shipmentData.deliveryState}} {{shipmentData.deliveryZipCode}}</p>
                    <p v-if="shipmentData.Address1">{{shipmentData.Address1}}, {{shipmentData.City}}, {{shipmentData.State}} {{shipmentData.ZipCode}}</p>
                    <button class="main-button-blue-white" @click="editEnteredAddress()">Edit</button>
                </div>
                <h3 v-if="correctedAddress">Corrected Address</h3>
                <h3 v-else>Address Validation Error</h3>
                <p v-if="correctedAddress">{{correctedAddress}}</p>
                <p v-else>We could not validate the address you entered.</p>
            </div>
            <button v-if="correctedAddress" @click="useCorrectedAddress()" class="main-button-blue-white">Use Corrected Address</button>
            <button v-else class="main-button-blue-white" @click="editAddress()">I want to edit the address</button>
            <button @click="useEnteredAddress()" class="main-button-orange-white">Use Address As Entered</button>
        </div>
    </div>
</template>

<script>
import { API } from "aws-amplify";

const resolvePlaceMutation = `mutation resolvePlace($input: ResolvePlaceInput!) {
  resolvePlace(input: $input) {
    placeID
    placeCode
    latitude
    longitude
    relevance
    address1
    address2
    city
    state
    zipCode
    serviceAddressType
    operatorTitle
    timeWindowStart
    timeWindowEnd
    timeWindowType
  }
}`;

export default {
    props: ['shipmentData', 'customAddress', 'currentActive', 'showPickupLogic', 'authMode'],
    data() {
        return {
            toggleCustomAddressCorrection: false,
            correctedAddress: "",
            resolvedPlace: null,
            shipmentAddressData: {
                latitude: '',
                longitude: '',
                relevance: '',
                Address1: '',
                State: '',
                ZipCode: '',
                City: '',
                placeID: '',
                placeCode: ''
            }
        };
    },
    watch: {
        'customAddress': function () {
            this.getLocationData();
        }
    },
    methods: {
        async editAddress() {
            this.toggleCustomAddressCorrection = false;
        },

        /**
         * Calls resolvePlace mutation to validate/geocode the address via CorePlaceAddress.
         * Replaces the old AWS Location Services searchPlaceIndexForText call.
         */
        async getLocationData() {
            try {
                const graphqlOptions = {
                    query: resolvePlaceMutation,
                    variables: { input: { fullAddress: this.customAddress } },
                };
                if (this.authMode) graphqlOptions.authMode = this.authMode;
                const response = await API.graphql(graphqlOptions);

                const place = response.data.resolvePlace;
                this.setCustomAddress(place);
            } catch (err) {
                console.error("Error resolving place:", err);
                // Show correction UI with no suggestion
                this.correctedAddress = "";
                this.resolvedPlace = null;
                this.toggleCustomAddressCorrection = true;
                this.$emit('editEnteredAddress', { customAddress: "" });
                this.scrollToTop();
            }
        },

        setCustomAddress(place) {
            // Zero-candidate response — no valid result from Esri
            if (!place || (!place.placeID && place.relevance === "0")) {
                this.correctedAddress = "";
                this.resolvedPlace = null;
                this.toggleCustomAddressCorrection = true;
                this.$emit('editEnteredAddress', { customAddress: "" });
                this.scrollToTop();
                return;
            }

            const relevance = place.relevance ? parseFloat(place.relevance) : 0;

            if (relevance <= 0.95) {
                // Low confidence — show correction UI
                this.toggleCustomAddressCorrection = true;
                this.resolvedPlace = place;
                if (place.address1) {
                    this.correctedAddress = `${place.address1}, ${place.city}, ${place.state} ${place.zipCode}`;
                } else {
                    this.correctedAddress = "";
                }
                this.scrollToTop();
            } else {
                // High confidence — auto-accept
                this.shipmentAddressData.latitude = place.latitude;
                this.shipmentAddressData.longitude = place.longitude;
                this.shipmentAddressData.relevance = place.relevance;
                this.shipmentAddressData.Address1 = place.address1 || "";
                this.shipmentAddressData.City = place.city || "";
                this.shipmentAddressData.State = place.state || "";
                this.shipmentAddressData.ZipCode = place.zipCode || "";
                this.shipmentAddressData.placeID = place.placeID || "";
                this.shipmentAddressData.placeCode = place.placeCode || "";

                this.$emit('setCustomAddress', {
                    shipmentAddressData: this.shipmentAddressData,
                    callStepNext: true,
                    callInsertAddressBook: true
                });
                this.correctedAddress = "";
                this.resolvedPlace = null;
            }
        },

        scrollToTop() {
            window.scrollTo(0, 0);
        },

        useCorrectedAddress() {
            if (!this.resolvedPlace) return;

            this.shipmentAddressData.latitude = this.resolvedPlace.latitude;
            this.shipmentAddressData.longitude = this.resolvedPlace.longitude;
            this.shipmentAddressData.relevance = "1";
            this.shipmentAddressData.Address1 = this.resolvedPlace.address1 || "";
            this.shipmentAddressData.City = this.resolvedPlace.city || "";
            this.shipmentAddressData.State = this.resolvedPlace.state || "";
            this.shipmentAddressData.ZipCode = this.resolvedPlace.zipCode || "";
            this.shipmentAddressData.placeID = this.resolvedPlace.placeID || "";
            this.shipmentAddressData.placeCode = this.resolvedPlace.placeCode || "";

            this.toggleCustomAddressCorrection = false;
            this.$emit('useCorrectedAddress', {
                shipmentDataValue: this.shipmentAddressData,
                callStepNext: true,
                callInsertAddressBook: true
            });
            this.correctedAddress = "";
            this.resolvedPlace = null;
        },

        useEnteredAddress() {
            this.toggleCustomAddressCorrection = false;
            this.$emit('useEnteredAddress', { callStepNext: true, callInsertAddressBook: true });
        },

        editEnteredAddress() {
            this.toggleCustomAddressCorrection = false;
            this.$emit('editEnteredAddress', { customAddress: "" });
        }
    }
};
</script>

<style scoped>
@import "../../styles/button-styles.css";

.custom-address-suggestion-container {
    width: 100%;
    height: 150%;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 99;
    background: rgba(15, 23, 42, 0.4);
    backdrop-filter: blur(2px);
    padding-top: 40px;
}

.custom-address-inner-container {
    padding: 28px 32px;
    background-color: #ffffff;
    border-radius: 12px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15), 0 4px 16px rgba(0, 0, 0, 0.08);
    z-index: 15;
    position: relative;
    max-width: 480px;
    width: 90%;
    animation: slideDown 0.25s ease-out;
}

@keyframes slideDown {
    from {
        opacity: 0;
        transform: translateY(-12px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.custom-address-text {
    text-align: left;
}

.custom-address-text h3 {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    color: #475569;
    background-color: #f1f5f9;
    border-radius: 6px;
    margin: 0 0 10px 0;
    padding: 8px 12px;
    border-left: 3px solid #3b82f6;
}

.custom-address-text p {
    font-size: 14px;
    color: #1e293b;
    margin: 0 0 16px 0;
    line-height: 1.5;
}

.entered-address-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 20px;
    padding: 12px 14px;
    background-color: #fafafa;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
}

.entered-address-container p {
    margin: 0;
    margin-right: auto;
    font-size: 13px;
    color: #334155;
    font-weight: 500;
}

.entered-address-container button {
    padding: 5px 12px;
    font-size: 12px;
    border-radius: 6px;
    margin-left: 12px;
    flex-shrink: 0;
}

button {
    margin: 4px 4px 4px 0;
    padding: 10px 20px;
    font-size: 13px;
    font-weight: 500;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.15s ease;
    border: none;
}

.main-button-blue-white {
    background-color: #3b82f6;
    color: #ffffff;
}

.main-button-blue-white:hover {
    background-color: #2563eb;
    box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
}

.main-button-orange-white {
    background-color: #f8fafc;
    color: #475569;
    border: 1px solid #e2e8f0;
}

.main-button-orange-white:hover {
    background-color: #f1f5f9;
    border-color: #cbd5e1;
}

h2, h3 {
    width: auto;
    text-align: left;
}
</style>
